import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import LoadingProgress from "../../../../components/LoadingProgress";
import CrudTable from "./CrudTable";
import CrudFilters from "./CrudFilters";
import CrudForm from "./CrudForm";

export default function CrudSection({
    items, onAdd, onEdit, onDelete, loading,
    fieldsTable, fieldsForm, regionOptions, refCallback, type, provinceOptions, countryOptions, comarcaOptions
}) {
    const [open, setOpen] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [form, setForm] = useState({});
    const [filters, setFilters] = useState({});

    useEffect(() => {
        if (editItem) setForm(editItem);
        else setForm({});
    }, [editItem, open]);

    useEffect(() => {
        if (typeof refCallback === "function") {
            refCallback(() => handleOpen());
        }
    }, [refCallback]);

    const handleOpen = (item = null) => {
        setEditItem(item);
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setEditItem(null);
    };
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handleSubmit = () => {
        if (editItem) onEdit(form, handleClose);
        else onAdd(form, handleClose);
    };
    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const filteredItems = items.filter(item =>
        fieldsTable.every(f => {
            const filterValue = filters[f.name];
            if (!filterValue) return true;
            const itemValue = (item[f.name] || "").toString().toLowerCase();
            return itemValue.includes(filterValue.toLowerCase());
        })
    );

    return (
        <>
            <CrudFilters
                fields={fieldsTable}
                filters={filters}
                handleFilterChange={handleFilterChange}
            />
            {loading ? <LoadingProgress /> : (
                <CrudTable
                    fields={fieldsTable}
                    filteredItems={filteredItems}
                    filters={filters}
                    handleOpen={handleOpen}
                    onDelete={onDelete}
                />
            )}
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        borderRadius: "16px",
                        width: 450
                    }
                }}
            >
                <DialogTitle sx={{ textAlign: "center" }}>
                    {editItem ? "Editar" : "Añadir"} {type ? type.charAt(0).toUpperCase() + type.slice(1) : ""}
                </DialogTitle>
                <DialogContent>
                    <CrudForm
                        fields={fieldsForm}
                        form={form}
                        handleChange={handleChange}
                        regionOptions={regionOptions}
                        provinceOptions={provinceOptions}
                        countryOptions={countryOptions}
                        comarcaOptions={comarcaOptions}
                        setForm={setForm}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16, marginTop: 20 }}>
                        <div style={{ width: "50%" }}>
                            <Button
                                onClick={handleClose}
                                variant="contained"
                                className="MuiButton-containedCancel"
                                fullWidth
                            >
                                Cancelar
                            </Button>
                        </div>
                        <div style={{ width: "50%" }}>
                            <Button
                                onClick={handleSubmit}
                                color="primary"
                                variant="contained"
                                fullWidth
                            >
                                Guardar
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}
